<template>
  <el-table-column
    prop="source_storage_name"
    sortable="custom"
    label="Forrás raktár"
    show-overflow-tooltip
    min-width="150"
  />
</template>

<script>
  export default {
    propName: 'source_storage_name',
  };
</script>
